module.exports = __webpack_public_path__ + "static/media/HRECOS_Stations_Norrie.396908b4.jpg";